import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Adnan Kahveci Koltuk Yıkama", path: "/beylikduzu/adnan-kahveci-koltuk-yikama" },
  { label: "Adnan Kahveci Yorgan Yıkama", path: "/beylikduzu/adnan-kahveci-yorgan-yikama" },
  { label: "Barış Mahallesi Koltuk Yıkama", path: "/beylikduzu/baris-koltuk-yikama" },
  { label: "Barış Mahallesi Perde Yıkama", path: "/beylikduzu/baris-perde-yikama" },
  { label: "Yakuplu Koltuk Yıkama", path: "/beylikduzu/yakuplu-koltuk-yikama" },
  { label: "Yakuplu Battaniye Yıkama", path: "/beylikduzu/yakuplu-battaniye-yikama" },
  { label: "Gürpınar Koltuk Yıkama", path: "/beylikduzu/gurpinar-koltuk-yikama" },
  { label: "Gürpınar Kuru Temizleme", path: "/beylikduzu/gurpinar-kuru-temizleme" },
  { label: "Kavaklı Koltuk Yıkama", path: "/beylikduzu/kavakli-koltuk-yikama" },
  { label: "Kavaklı Yerinde Yıkama", path: "/beylikduzu/kavakli-yerinde-yikama" },
  { label: "Beylikdüzü Merkez Koltuk Yıkama", path: "/beylikduzu/merkez-koltuk-yikama" }
];

const BeylikduzuServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BEYLİKDÜZÜ HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BeylikduzuServiceArea;
